import { render, staticRenderFns } from "./NailBarDemo.vue?vue&type=template&id=5caeada9&scoped=true&"
import script from "./NailBarDemo.vue?vue&type=script&lang=js&"
export * from "./NailBarDemo.vue?vue&type=script&lang=js&"
import style0 from "./NailBarDemo.vue?vue&type=style&index=0&id=5caeada9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caeada9",
  null
  
)

export default component.exports